import * as React from "react";
// import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const MerchPage = () => {
	return (
		<Layout>
			<Seo title="Now" />
			<h2>Now</h2>
			<div className="main--centerwrapper">
				<StaticImage
					src="../images/photos/pressRes/Jesse_Rivest_Toadstool_007.jpg"
					alt="Jesse Rivest press image"
					placeholder="blurred"
					layout="constrained"
					className="main--centered"
					imgClassName="img--bordered-small"
					width={500}
				/>
			</div>

			<h3>What am I doing now?</h3>
			<p>
				Updated March 6, 2026, from a sunny day after refreshing Brasilia rain.<br />
				(This is a <span className="italic">now page</span> in the style of Derek Sivers.)
			</p>

			<h4>Writing a lot of songs</h4>
			<p>
				I started the year off with something very, very cool:
				a songwriting and production workshop with Blake Mills via the School of Song platform.
				I had not heard of School of Song; it was through Blake's social media post that I learned of the workshop and got excited.
				I have been an admirer of Blake Mills for five or six years now, like, I really admire him.
				I love his work!
				The month-long workshop was so satisfying: I wrote and recorded three new songs in January and met some new people online.
				(School of Song workshops are online.)
				I noticed a couple artists from my hometown (I recognized them from a band that I really like) were also attending and participating,
				so at the end I reached out to one of them for a wee messaging chat.
				Glad I did, because next thing you know he invited me into an online songwriting group that he manages!
				Now, part of his group, I've written two more songs and am about to (today) start a third.
				If I keep this up—writing a song every two weeks—I'll have over 25 new ones by the end of the year.
				However, it's the ongoing activity and exercise of the art form that I was really craving, and I feel satisfied with this path.
				The only issue is I feel a new confusion:
				I have been letting go of practicing my repertoire.
				I feel pretty strange about it. Old, old songs only need to be revisited a handful of times per year and I won't lose them.
				But songs (covers and originals) from more recent years need more attention, and I don't want to lose them.
				I am spending most/all of my available me-music time now on songwriting and producing what I've written.
				I think I best return to an evening per week where I run through a handful to refresh my memory.
			</p>

			<h4>A little frustrated with (software) package maintainers</h4>
			<p>
				In the months following the Shai-Hulud NPM worm/exploit, I did nothing.
				My yarn.lock files haven't been edited for years—that's how active I've been.
				Yesterday I went to freeze dependency versions in package.json and found that the resulting yarn.lock files broke my project.
				(My project, in this case, is this website.)
				I spent a lot of time chasing dependency chains and trying to freeze versions, and then asked msyelf if it is worth it:
				If I keep yarn.lock frozen in time a bit longer, it is safe; for now, I just need to update content on my website.
				Still, I was left frustrated with a particular developer—who knows, maybe others,
				too—for doing silly things like specifying dependencies to be "latest version".
				Specifying is an oxymoron here, for it is a complete lack of specification with boundless limits that allows any version,
				i.e., the latest and greatest, to enter my project as a sub-dependency.
				As we saw with Shai-Hulud, the "latest and greatest" slipped onto countless developer machines and wormed its way through 500+ packages.
				What could ever be a good reason for not specifying a version limit on your (sub-)dependencies?
				Specifying that you accept patches or minor updates—this I understand.
				But specifying that you accept the latest to me seems like laziness or carelessness.
				Couldn't you imagine a scenario where a major update comes along and breaks compatibility with a project?
				This same developer removed support for Node.js versions 16 and 18 and then a year or more later restored support to version 18.
				That's just crazy. Break some dependent projects and then sneak back in some support? Weird.
				Well, end of rant, I suppose.
				Next time I do update dependencies for this project—when I finally get it to run again with a working yarn.lock and a yarn audit indicates no major critical vulnerabilities—I think
				I'll spend the extra time to go through yarn.lock, find all vague version ranges, and secure my package.json with the exact installed versions.
				Sigh.
			</p>

			<h4>Reading</h4>
			<p>
				I've given up toward the end of <span className="italic">The Precipice</span>, by Toby Ord.
				The book was mailed to my by 80,000 Hours as consolation (and inspiration) after I was rejected for one-on-one advising in the job market.
				I feel the weight and importance of the subject matter, and I appreciate the rigorous analysis, but I have lost the drive to finish the book.
				I am trying to re-establish routine reading now with <span className="italic">David Copperfield</span> (Dickens) and <span className="italic">Brighton Rock</span>, by Graham Greene.
				The print in both of these books is quite small; this has never been a problem in my life but, recently, it has become one.
				I think it's time for reading glasses? I'm currently using a cheap magnifying glass (the kind that kids use to burn ants).
			</p>

			<h4>Watching</h4>
			<p>
				Jane and I celebrated our anniversary at the cinema where we first met; this time we saw <span className="italic">Sentimental Value</span>, by Joachim Trier.
				We loved it! That's not surprising, though, as I previously really enjoyed Trier's "Oslo trilogy".
				I laughed out loud in the cinema, even though the film is clearly a drama... it is certainly situationally funny, as well.
			</p>

			<h4>Listening</h4>
			<p>
				Exciting times! The new Iron & Wine album, <span className="italic">Hen's Teeth</span>, just dropped and has been on high rotation the past week;
				and I've already given two spins to Lucas Santtana's new album, <span className="italic">Brasiliano</span>. I am digging it.
				I have also given numerous spins to a new Robbie Lackritz production: <span className="italic">Best of Our Possible Lives</span>, by Boy Golden.
				I fell right into its vibe and groove and have recommended it to my production/writing colleagues and friends.
			</p>


		</Layout>
	);
}

export default MerchPage;
